import useProjectViews from '@API/project/useProjectViews';
import { useDashboardApiContext } from '@projects/components/EMDashboardPage/useDashboardAPIContext';
import { DeleteViewModalProps } from '@shared/components/ViewSelect/modals/DeleteViewModal';
import { useMemo, useState } from 'react';

const useDashboardViewDelete = () => {
  const [modalOpened, setModalOpened] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const { data: templates = [] } = useProjectViews();
  const { isRemovingTemplate, removeTemplate } = useDashboardApiContext();

  const viewToDelete = useMemo(
    () => templates.find(view => view.templateId === deleteId),
    [deleteId, templates]
  );

  const onDeleteTemplate = (id: string) => {
    setDeleteId(id);
    setModalOpened(true);
  };

  const onClose = () => setModalOpened(false);

  const deleteModalConfig: DeleteViewModalProps = useMemo(
    () => ({
      onConfirm: () => {
        if (!viewToDelete || !viewToDelete.templateId) return;

        removeTemplate({
          projectId: viewToDelete.projectId,
          viewId: viewToDelete.templateId,
          isDefaultView: !!viewToDelete.projectDefault,
          onSuccess: () => {
            onClose();
          },
          // @todo: is this the correct check?
          isSelectedTemplate: viewToDelete.current
        });
      },
      onClose,
      isOpened: modalOpened,
      name: viewToDelete?.templateName,
      isLoading: isRemovingTemplate
    }),
    [isRemovingTemplate, modalOpened, removeTemplate, viewToDelete]
  );

  return {
    deleteModalConfig,
    onDeleteTemplate
  };
};

export default useDashboardViewDelete;
